import React, { useEffect, useState } from "react";
import { Spinner, useToast } from "@chakra-ui/react";
import { Subject } from "../../common/types";
import { H2Error } from "../../common/components/Texts";
import InputSubject from "./components/InputSubject";
import useLazyRequest from "../../common/hooks/useLazyRequest";
import { useDispatch, useSelector } from "react-redux";
import { subjectActions, subjectState } from "../../store/slices/subject";

interface OwnProps {
    id: string;
    isOpen: boolean;
    onClose: () => void;
}

const EditSubject = ({ id, isOpen, onClose }: OwnProps) => {
    const [hasUpdated, setHasUpdated] = useState(false);
    const toast = useToast();
    const dispatch = useDispatch();
    const { isSaving, hasErrorSaving } = useSelector(subjectState);
    const [{ isLoading, hasError, data }, getSubject] = useLazyRequest<Subject>(
        "GET",
        `/subject/${id}`
    );

    useEffect(() => {
        if (id && isOpen) {
            getSubject();
        }
    }, [id, isOpen]);

    useEffect(() => {
        if (hasUpdated && !isSaving) {
            if (hasErrorSaving) {
                toast({
                    title: "No se puede actualizar el Tema.",
                    description:
                        "Se ha encontrado un error. Por favor intenta nuevamente.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: "Tema actualizado.",
                    description: "Se ha actualizado correctamente.",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                onClose();
            }
        }
    }, [hasUpdated, isSaving, hasErrorSaving]);

    return (
        <>
            {isLoading && <Spinner />}
            {!isLoading && hasError && (
                <H2Error text="Ha ocurrido un error y no se puede cargar tu Tema. Por favor intenta nuevamente." />
            )}
            {!isLoading && !hasError && data && (
                <InputSubject
                    isOpen={isOpen}
                    isSubmitting={isSaving}
                    onClose={onClose}
                    onSave={(data) => {
                        setHasUpdated(true);
                        dispatch(
                            subjectActions.updateSubject({
                                id,
                                payload: data,
                            })
                        );
                    }}
                    defaultData={data}
                    onDelete={
                        () => {
                            dispatch(subjectActions.deleteSubject(id));
                            onClose();
                        }
                    }
                />
            )}
        </>
    );
};

export default EditSubject;
